import { ISurveyReducer } from './models/ISurveyReducer';
import injectReducer from '../../store/injectReducer';
import * as types from './ActionTypes';
import {
	failureActionHandler,
	requestActionHandler,
	successActionHandler,
} from '../../store';
import {
	IRespondentData,
	IGeneralInfoModule,
	IRatingsModule,
	IEvaluationModule,
	IProgressBarProps,
} from './models';
import { IRedirectData } from './models/IRedirectData';

export const InitialSurveyReducer: ISurveyReducer = {
	isLoading: false,
	isQuestionLoading: false,
	activeModule: 0,
	moduleProgress: {
		total: 0,
		activeStep: 0,
	},
};

export default injectReducer(InitialSurveyReducer, {
	[types.GET_RESPONDENT_DATA.REQUEST]: requestActionHandler,

	[types.GET_RESPONDENT_DATA.FAILURE]: failureActionHandler,
	[types.GET_MODULE_GENERAL_INFO.FAILURE]: failureActionHandler,
	[types.GET_MODULE_RATINGS.FAILURE]: failureActionHandler,
	[types.GET_MODULE_EVALUATION.FAILURE]: failureActionHandler,

	[types.POST_SURVEY_DATA.REQUEST]: (state: ISurveyReducer) => ({
		...state,
		isQuestionLoading: true,
	}),
	[types.GET_MODULE_GENERAL_INFO.REQUEST]: (state: ISurveyReducer) => ({
		...state,
		isQuestionLoading: true,
	}),
	[types.GET_MODULE_RATINGS.REQUEST]: (state: ISurveyReducer) => ({
		...state,
		isQuestionLoading: true,
	}),
	[types.GET_MODULE_EVALUATION.REQUEST]: (state: ISurveyReducer) => ({
		...state,
		isQuestionLoading: true,
	}),

	[types.POST_SURVEY_DATA.FAILURE]: failureActionHandler,
	[types.GET_MODULE_GENERAL_INFO.FAILURE]: failureActionHandler,
	[types.GET_MODULE_RATINGS.FAILURE]: failureActionHandler,
	[types.GET_MODULE_EVALUATION.FAILURE]: failureActionHandler,

	[types.GET_RESPONDENT_DATA.SUCCESS]: (
		state: ISurveyReducer,
		{ payload }: { payload: IRespondentData },
	) => ({
		...successActionHandler(state),
		respondentData: payload,
	}),

	[types.GET_MODULE_GENERAL_INFO.SUCCESS]: (
		state: ISurveyReducer,
		{ payload }: { payload: IGeneralInfoModule },
	) => ({
		...successActionHandler(state),
		generalInfoModule: payload,
		isQuestionLoading: false,
	}),

	[types.GET_MODULE_RATINGS.SUCCESS]: (
		state: ISurveyReducer,
		{ payload }: { payload: IRatingsModule },
	) => ({
		...successActionHandler(state),
		ratingsModule: payload,
		isQuestionLoading: false,
	}),

	[types.GET_MODULE_EVALUATION.SUCCESS]: (
		state: ISurveyReducer,
		{ payload }: { payload: IEvaluationModule },
	) => ({
		...successActionHandler(state),
		evaluationModule: payload,
		isQuestionLoading: false,
	}),

	[types.POST_SURVEY_DATA.SUCCESS]: (state: ISurveyReducer) => ({
		...successActionHandler(state),
		isQuestionLoading: false,
	}),

	[types.SET_ACTIVE_MODULE]: (
		state: ISurveyReducer,
		{ payload }: { payload: number },
	) => ({
		...successActionHandler(state),
		isLoading: state.isLoading,
		activeModule: payload,
	}),

	[types.RESET_FINISH_MODULE]: (state: ISurveyReducer) => ({
		...successActionHandler(state),
		isModuleFinished: false,
	}),

	[types.SET_PROGRESS]: (
		state: ISurveyReducer,
		{ payload }: { payload: IProgressBarProps },
	) => ({
		...state,
		moduleProgress: payload,
	}),

	[types.FINISH_SURVEY]: (
		state: ISurveyReducer,
		{
			payload: { redirect },
		}: {
			payload: {
				redirect: IRedirectData | null;
			};
		},
	) => ({
		...state,
		isSurveyFinished: true,
		redirect,
	}),
});
